const audiences = [
  { name: 'Government', desc: 'Departments, ministries and schemes', icon: 'ri-government-line' },
  { name: 'Public Sector', desc: 'PSUs and public enterprises', icon: 'ri-building-line' },
  { name: 'Institutions', desc: 'Universities, bodies and foundations', icon: 'ri-organization-chart' },
  { name: 'Public Leadership', desc: 'Elected representatives & offices', icon: 'ri-user-star-line' },
  { name: 'Political Organisations', desc: 'Parties and public movements', icon: 'ri-team-line' },
];

export default function WhoWeWorkWith() {
  return (
    <section className="relative w-full bg-primary-950 py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-grid-fine opacity-20 pointer-events-none" style={{ backgroundSize: '72px 72px' }}></div>
      <div className="absolute -left-24 top-10 w-96 h-96 rounded-full bg-accent-500/10 blur-3xl pointer-events-none"></div>

      <div className="relative px-6 md:px-16 lg:px-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          {/* Left — copy */}
          <div className="lg:sticky lg:top-28">
            <div className="flex items-center gap-3 mb-4">
              <span className="text-[10px] tracking-[0.3em] uppercase text-accent-400 font-mono">03 / Who we work with</span>
            </div>
            <h2 data-reveal className="text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.08] text-white tracking-tight font-semibold drop-shadow-lg">
              Built for complex public challenges.
            </h2>
            <p data-reveal="fade" style={{ ['--reveal-delay' as never]: '120ms' }} className="mt-6 max-w-md text-[15px] md:text-base leading-[1.8] text-white/70">
              The Prabhaw venture is designed around the full scope of public work —
              from government departments and public sector enterprises to
              institutions, elected representatives and political organisations.
            </p>
            <p data-reveal="fade" style={{ ['--reveal-delay' as never]: '200ms' }} className="mt-4 max-w-md text-[15px] leading-[1.8] text-white/70">
              Our discipline is the same across every partner: understand the ground,
              bring evidence, design the strategy, and deliver measurable impact.
            </p>

            <div data-reveal="fade" style={{ ['--reveal-delay' as never]: '280ms' }} className="mt-8 inline-flex items-center gap-3 rounded-md border border-accent-500/40 bg-accent-500/10 px-4 py-3">
              <i className="ri-verified-badge-line w-5 h-5 flex items-center justify-center text-accent-400"></i>
              <p className="text-[13px] text-white leading-snug max-w-xs">
                One integrated venture — technology and execution, fused with research, strategy and stakeholder capability.
              </p>
            </div>
          </div>

          {/* Right — audience list */}
          <div data-reveal-stagger className="flex flex-col gap-4">
            {audiences.map((a, i) => (
              <a
                href="#capabilities"
                key={a.name}
                className="stagger-child group flex items-center gap-5 rounded-2xl border border-white/15 bg-white/5 px-6 md:px-8 py-6 transition-colors duration-300 hover:border-accent-500/50 hover:bg-white/10 cursor-pointer"
              >
                <span className="text-sm font-mono text-white/60">0{i + 1}</span>
                <span className="w-12 h-12 rounded-lg bg-accent-500/15 flex items-center justify-center shrink-0 group-hover:bg-accent-500 group-hover:text-primary-950 transition-colors">
                  <i className={`${a.icon} w-6 h-6 flex items-center justify-center text-accent-400 group-hover:text-primary-950`}></i>
                </span>
                <div className="flex-1">
                  <p className="text-lg md:text-xl tracking-wide text-white font-medium group-hover:text-accent-300 transition-colors">
                    {a.name}
                  </p>
                  <p className="text-[13px] text-white/50 mt-0.5">{a.desc}</p>
                </div>
                <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center text-white/40 group-hover:text-accent-400 group-hover:translate-x-1 transition-all"></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}